import React, { useEffect, useState } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../../services/helpers';
import { httpRequest } from '../../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../../parts/Loader';
import store from '../../../../services/store';
import images from '../../../../services/images';
import initTreeView from '../../../../services/initTreeView';
import StoreInfo from '../../../parts/StoreInfo';
import { getApiData } from '../../../../services/apiService';
import { serviceRequestData } from '../../../../services/serviceHubStore';
import { QRCode } from 'react-qrcode-logo';

export default function BookingPrintView (){
    const { booking_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [bookingDetails, setBookingDetails] = useState([]);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [load_status, setStatus] = useState(0);
    const [account, setAccount] = useState([]);
   
    useEffect(() => {
        initTreeView()
        
        //const customer_id = helpers.getURLParams('customer_id');
        //const request_from = helpers.getURLParams('request_from');
        //const request_to = helpers.getURLParams('request_to');
        //if(customer_id && request_from && request_to){
            fetchAccount()
        //}
    }, []);

    useEffect(() => {
        if(load_status){
            setTimeout(function(){
                //window.print()
            }, 2000);
        }
    }, [load_status]);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    async function fetchAccount(){
        let endpoint = helpers.createUrl(`V1/account/profile`)
        const res = await getApiData(endpoint)

        if(res){
            setAccount(res.data)
            fetchData()
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/ship-booking/bookings");
                }
            })
        }
    }

    async function fetchData(){
        //const endpoint = helpers.createShipBookingHubUrl(`voyage/${booking_id}/manifest`)
        const endpoint = helpers.createShipBookingHubUrl(`booking/${booking_id}`)

        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            setBookingDetails(res)
            setRecordItems(res.details)
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/ship-booking/bookings");
                }
            })
        }
    }

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                let counter = parseInt(key) + 1
                console.log('id', data)
                return(
                    <>
                        <tr>
                            <td>{counter}</td>
                            <td>{data?.plate_number ? data.plate_number : 'N/A'}</td>
                            {/* <td>1 unit</td> */}
                            <td>{`${data?.brand} | ${data?.model_name}`}</td>
                            <td>{data?.driver ? data.driver : 'N/A'}</td>
                            <td>₱{helpers.formatAmount(data.unit_price)}</td>
                            <td width={100}>
                                <QRCode 
                                    value={`${data.id}`} 
                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }} 
                                    fgColor="#000"
                                    //logoImage={images.polarair_icon}
                                    ecLevel="H"                      // 1. ADD THIS: High error correction
                                    //removeQrCodeBehindLogo={true}    // 2. UNCOMMENT THIS: Clears modules
                                    //logoPadding={1}                  // 3. ADD THIS: Small buffer for scanning
                                    qrStyle="squares"
                                    //logoWidth={50}
                                    //logoHeight={70}
                                    quietZone={0}
                                />
                            </td>
                        </tr>
                    
                        <tr>
                        </tr>
                    </>
                )
            })

            items.push(
                <tr>
                    <th className='bg-light' colSpan={7}>
                        Total Unit Count: 
                        <span className='font-weight-normal ml-1'> {record_items?.length} {record_items?.length > 1 ? ' units' : ' unit'}</span>
                    </th>
                </tr>
            )
        }
        else{
            items =  
                    <tr>
                        <td colSpan={10} className='text-center'>No data to display.</td>
                    </tr>
        }


        setTableItems(<tbody>{items}</tbody>)
        setStatus(1)
    }

    function computeSubTotals(){
        let items = 0;
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            items = items + Number(data.quantity)
            total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        });

        return helpers.formatCurrencyAmount(total_amount);
    }


    function getCurrentDateTime() {
        const now = new Date();

        // 1. Format the Date: "14 May 2026"
        const datePart = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        }).format(now);

        // 2. Format the Time: "02:28:31PM"
        const timePart = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        }).format(now).replace(/\s/g, '');

        // 3. Combine with a comma
        return `${datePart}, ${timePart}`;
    }

    function formatManifestDateTime(inputString) {
        // Replace the space with 'T' to ensure cross-browser compatibility
        const date = new Date(inputString.replace(' ', 'T'));

        // Format Date: 16 May 2026
        const datePart = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(date);

        // Format Time: 7:00PM
        const timePart = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(date).replace(/\s/g, '');

        return `${datePart}, ${timePart}`;
    }

    return (
        <div className="invoice p-4 mb-3">
            <Loader isLoading={loading}/>

            <div className="d-flex justify-content-between mb-3">
                <div>
                    {/* <img src={images.main_logo} height={80} className='float-left mr-3' /> */}
                    <p className='mb-0'><b>San Ricardo Shipping Lines Corp.</b></p>
                    <p className='mb-0' style={{fontSize: '14px'}}>www.sanricardoshipping.com</p>
                    <p className='mb-0' style={{fontSize: '14px'}}>Port Area, Brgy. Benit, San Ricardo, Southern Leyte 6617</p>
                </div>
                <div>
                    <h5 className='text-center'><strong>BOOKING DETAILS</strong></h5>
                    {/* <QRCode 
                        value={`${window.location.host}/ship-booking/bookings/${booking_id}`} 
                        style={{ height: "auto", width: "50px" }} 
                        fgColor="#000"
                        ecLevel="H"                      // 1. ADD THIS: High error correction
                        qrStyle="squares"
                        quietZone={0}
                    /> */}
                </div>
            </div>

            <hr/>

            <div className="d-flex justify-content-between mb-3">
                <div>
                    <p className='mb-0'>Booking No: <b>{bookingDetails?.booking_ref ? bookingDetails?.booking_ref : '---'}</b></p>
                    <p className='mb-0'>Booking Date: <b>{helpers.formatDisplayDate(bookingDetails?.booking_date)}</b></p>
                    <p className='mb-0'>Booking Type: <b>{bookingDetails.trip_type == 'one-way' ? 'One Way' : 'Round Trip'}</b></p>
                    <p className='mb-0'>Customer: <b>{bookingDetails?.customer_name ? bookingDetails?.customer_name : '---'}</b></p>
                </div>
                <div>
                    <p className='mb-0'>Departure Date/Time: <b>{helpers.formatManifestDateTime(bookingDetails.departure_time)}</b></p>
                    <p className='mb-0'>Route: {bookingDetails?.origin}<span className='text-primary mx-1'>&rarr;</span>{bookingDetails?.destination}
                    </p>
                    <p className='mb-0'>Trip Type: <b>{helpers.ucwords(bookingDetails.trip_type)}</b></p>
                    <p className='mb-0'>Total Amount: <b>₱{helpers.formatAmount(bookingDetails.total_amount)}</b></p>
                </div>
            </div>

            <div className='table-responsives mb-2'>
                <table className='table table-bordered table-stripeds table-sm border-bottom mb-0'>
                    <thead class="thead-dark">
                        <tr>
                            <th>No.</th>
                            <th>Plate Number</th>
                            <th>Vehicle Description</th>
                            <th>Driver(s)</th>
                            <th>Price</th>
                            <th>Scan</th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>

            {/* <div className='text-xs'>
                Generated Date: {helpers.getCurrentDateTime()}
            </div> */}

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>Generated Date: {helpers.getCurrentDateTime()}</small><br/>
                    <small>This is a system-generated report. Powered by Topventory One.</small>
                </div>
            </div>
        </div>
    )
}